/// <reference path="../Service/Service.ts" />
/// <reference path="../HTML/Div.ts" />
/// <reference path="../HTML/Container/CFlexContainer.ts" />
/// <reference path="../HTML/Container/List/List.ts" />
namespace HA.Core.Notification {
    import Container = HA.Core.HTML.Container;
    import Tag = HA.Core.HTML.Tag;
    import CFlexContainer = HA.Core.HTML.CFlexContainer;
    import List = HA.Core.HTML.List;

    export class HANotification extends HA.Core.Service.Service {

        public watch(data: Map<any, any>): void {
            getDataRepository().fetchData(data).then((rData: any) => {
                this.processAction(rData);
            });
        }

        public info(msg: any) {
            this.show(this.createInfo(msg));
        }

        public log(msg: any) {
            if (!(msg instanceof Map) && msg instanceof Object) {
                this._log(toMap(msg));
                return;
            }
            this._log(msg);
        }

        public _log(msg: any) {
            this.show(this.createLog(msg));
        }

        public isDebug(): boolean {
            return this.get("debug") === true;
        }

        public activateDebugMode(): void
        {
            this.addToData("debug", true);
            log2("Debug mode activated");
        }

        public deactivateDebugMode(): void
        {
            this.addToData("debug", false);
        }

        public setMainContainer(container: Container): void {
            container.appendChild(this.getNotificationContainer());
            container.hide("fixed");
            this.addToData("mcontainer", container);
        }

        protected show(tag: Tag) {
            if (this.isBusy()) {
                tag.hide();
            } else {
                this.setBusy();
                tag.show();
            }
            this.getNotificationContainer().addItem(tag);
        }

        protected showNext() {
            const first = this.getNotificationContainer().removeFirst();
            first.hide();
            const next = this.getNotificationContainer().getFirst();
            if (next) {
                next.show();
                return;
            }
            this.setNotBusy();
        }

        protected setNotBusy() {
            this.addToData("busy", false);
            this.getMainContainer().hide("fixed");
        }

        protected setBusy() {
            this.addToData("busy", true);
            this.getMainContainer().show();
        }

        /**
         * @returns {boolean}
         */
        protected isBusy() {
            return this.get("busy") === true;
        }

        protected createInfo(data: any): NotificationEntry {
            const me = this;
            let d = data;
            if (!(data instanceof Map)) {
                d = toMap({
                    end: () => {
                        me.showNext();
                    },
                    m: data,
                });
            } else {
                d.set("end", () => {
                    me.showNext();
                });
            }

            const info: NotificationEntry = new NotificationEntry(d);
            info.addClass("dlogcontainer");
            return info;
        }

        /**
         *
         * @param data
         * @returns {Div}
         */
        protected createLog(data: any) {
            const me = this;
            let d = data;
            if (!(data instanceof Map)) {
                d = toMap({
                    m: data,
                    end: () => {
                        me.showNext();
                    },
                });
            } else {
                d.set("end", () => {
                    me.showNext();
                });
            }

            const log: NotificationEntry = new NotificationEntry(d);
            log.addClass("dlogcontainer");
            return log;
        }

        /**
         *
         * @param data
         */
        protected initialize(data?: any) {
            super.initialize(data);
            setNotification(this);
            this.createNotificationContainer();
        }

        public processAction(data: Map<any, any>) {
            switch (data.get("t")) {
                case  "msg" :
                    this.info(data);
                    break;
                case  "bulk" :
                case  "steps" :
                    this.processBulkAction(data.get("steps"));
                    break;
                case  "idle" :
                    timeout(() => {
                        this.processAction(toMap(data.get("data")));
                    }, data.get("d"));
                    break;
                case  "watch" :
                    this.watch(data);
                    break;
                default :
                    getAppService().processAction(data);
                    break;
            }
        }

        protected processBulkAction(data: any[]) {
            for (const item of data) {
                this.processAction(toMap(item));
            }
        }

        private createNotificationContainer(): void {
            this.addToData("_notifs", new List({tag: new CFlexContainer({className: "c100"})}));
        }

        private getNotificationContainer(): List {
            return this.get("_notifs");
        }

        private getMainContainer(): Container {
            return this.get("mcontainer");
        }
    }
}
